import React from "react";
import { Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userState } from "../../stores/atoms";

function Header({ logout }) {
  const [user] = useRecoilState(userState);

  return (
    <div className="header">
      <Link to="/" className="txt-decoration-none txt-black">
        <div>
          <h3>
            <img className="logo width-90" src="../logo.png" alt="logo" />
          </h3>
        </div>
      </Link>
      <div className="pt-3 pb-3">
        <p className="font-bold txt-dark-gray">
          {user.company_name} {user.name}님
        </p>
        <Link to="/my-info">
          <button className="btn-white">내 정보</button>
        </Link>
        <button className="btn-white" onClick={logout}>
          로그아웃
        </button>
      </div>
    </div>
  );
}

export default Header;
